const Tab = ({ tabTitle, children, ...rest }) => {
	return <>{children}</>;
};

export default Tab;
